export const COLLECTOR_INVOICE_PENDING = 'pending'
export const COLLECTOR_INVOICE_OPEN = 'open'
export const COLLECTOR_INVOICE_CLOSED = 'closed'
export const COLLECTOR_INVOICE_CANCELLED = 'cancelled'
